export default __webpack_public_path__ + "static/radioactive_b.36d4af3280fd064935688f7083ce1116.svg";